<template>
    <v-card class="Report__card">
        <v-card-title>
            <span>{{ card.name }}</span>
            <v-spacer />
            <span class="Report__card__location">{{ step.name }}\{{ section.name }}</span>
        </v-card-title>
        <v-card-text>
            <div
                v-if="card.field"
                class="Report__fields"
            >
                <ReportField
                    v-for="(field, index) in card.field"
                    :key="index"
                    :field="field"
                />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import ReportField from '@/reports/Fields/ReportField';
export default {
    components: { ReportField },
    props: {
        card: {
            type: Object,
            required: true,
        },

        section: {
            type: Object,
            required: true,
        },

        step: {
            type: Object,
            required: true,
        }
    }
};
</script>

<style lang="scss">
.Report__card__location {
    font-weight: normal !important;
    font-size: 0.8rem;
    color: #888;
}
</style>
